import { UserType } from '../../entities';
import { SecurityRole, SecurityRoleType } from '../security.role';
import { EmployeeAdministrator } from './employee.administrator';

export class SystemAdministrator implements SecurityRole {

    _id = '078f8eee-1a17-4bc6-a6a9-c1f3682f6b08';
    system = true;
    hidden = true;
    type = UserType.SystemAdministrator;
    name = SecurityRoleType.SystemAdministrator;
    description = 'This role is used by the system';
    rights = [
        ...new EmployeeAdministrator().rights,
    ];

}

